export const getters = {
  getMaritalStatus: state => state.maritalStatus,
  getEmploymentStatus: state => state.employmentStatus,
  getTaxpayerJobs: state => state.taxpayerJobs,
  getSpouseJobs: state => state.spouseJobs,
  getEmploymentLoadingStatus: state => state.employmentLoadingStatus,
  getRealEstate: state => state.realEstate,
  getRealEstateLoadingStatus: state => state.realEstateLoadingStatus,
  getVehicles: state => state.vehicles,
  getVehiclesLoadingStatus: state => state.vehiclesLoadingStatus,
  getOtherAssets: state => state.otherAssets,
  getOtherAssetsLoadingStatus: state => state.anotherAssetsLoadingStatus,
  getHousehold: state => state.household,
  getHouseholdLoadingStatus: state => state.householdLoadingStatus,
  getItemDetails: state => state.itemDetails,
};
